
import { defineComponent } from 'vue'
import loading from './loading.vue'

export default defineComponent({
  components: { loading },
  name: 'PersonalityButton',
  props: {
    type: {
      type: String, // 'dark' 'white' 'link'
      default: 'dark'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingTheme: String
  },

  emits: ['click'],

  setup (props, { emit }) {
    function clickHandler (evt: PointerEvent) {
      if (props.disabled || props.loading) return

      emit('click', evt)
    }

    return {
      clickHandler
    }
  }
})
